import { RevenuesTypeRef } from '@/dto/scenario/eco/EcoReference';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class EcoRevenuesExt extends DtoExt {
  public revenuesTypeRef: RevenuesTypeRef | null;
  public ppaTakeOrPay: boolean | null = null;
  public minimumTakeOff: number | null = null;
  public contractDuration: number | null = null;
  public solarMonthlyFeePercentage: number | null;
  public solarMonthlyFeeYearlyInflation: number | null;
  public solarMonthlyFeeValue: number | null;
  public proportionOfSavings: number | null;
  public ppaPrice: number | null;
  public ppaYearlyInflation: number | null;

  constructor(options: Partial<EcoRevenuesExt> = {}) {
    super();
    this.revenuesTypeRef = options?.revenuesTypeRef ?? null;
    this.ppaTakeOrPay = options?.ppaTakeOrPay ?? null;
    this.minimumTakeOff = options?.minimumTakeOff ?? null;
    this.contractDuration = options?.contractDuration ?? null;
    this.solarMonthlyFeePercentage = options?.solarMonthlyFeePercentage ?? null;
    this.solarMonthlyFeeYearlyInflation = options?.solarMonthlyFeeYearlyInflation ?? null;
    this.solarMonthlyFeeValue = options?.solarMonthlyFeeValue ?? null;
    this.proportionOfSavings = options?.proportionOfSavings ?? null;
    this.ppaPrice = options?.ppaPrice ?? null;
    this.ppaYearlyInflation = options?.ppaYearlyInflation ?? null;
  }
}
